import { computed } from 'vue'

const DEFAULT_PER_PAGE = 15

export default function(paginationState: Pagination) {
  /**
   * 不正な値を排除したページネーション情報
   */
  const pagination = computed((): Pagination => {
    const _page = (Number.isInteger(paginationState.page) && paginationState.page)
      ? paginationState.page
      : 1

    const _totalCount = (Number.isInteger(paginationState.totalCount) && paginationState.totalCount)
      ? paginationState.totalCount
      : 0

    const _per = (Number.isInteger(paginationState.per) && paginationState.per)
      ? paginationState.per
      : DEFAULT_PER_PAGE

    const _totalPage = _totalCount && _per
      ? Math.ceil(paginationState.totalCount / paginationState.per)
      : 0

    return {
      page: _page,
      per: _per,
      totalCount: _totalCount,
      totalPage: _totalPage,
    }
  })

  return {
    // computed
    pagination,
  }
}
